import React, { useState } from 'react';
import { Home, Zap, LayoutGrid, Search, Settings, HelpCircle, Bell, User, Sun, Moon } from 'lucide-react';

const Sidebar = ({ activeView, setActiveView, theme, setTheme }) => {
  const navItems = [
    { id: 'home', icon: Home, label: 'Home' },
    { id: 'aiflow', icon: Zap, label: 'AI Flow' },
    { id: 'tasks', icon: LayoutGrid, label: 'Tasks', active: true },
  ];

  const bottomItems = [
    { id: 'help', icon: HelpCircle, label: 'Help' },
    { id: 'settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <div className="w-[72px] h-screen bg-sidebar border-r border-border flex flex-col items-center py-4">
      {/* Logo */}
      <div className="w-12 h-12 mb-8 bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] rounded-xl flex items-center justify-center cursor-pointer hover:scale-105 transition-transform">
        <Zap className="w-6 h-6 text-white" strokeWidth={2.5} />
      </div>

      {/* Top Navigation */}
      <div className="flex-1 flex flex-col gap-2 w-full px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.active;
          return (
            <button
              key={item.id}
              onClick={() => setActiveView && setActiveView(item.id)}
              className={`w-full h-12 rounded-xl flex items-center justify-center transition-all group relative ${
                isActive
                  ? 'bg-card text-foreground'
                  : 'text-muted hover:text-foreground hover:bg-card-hover'
              }`}
              title={item.label}
            >
              <Icon className="w-5 h-5" strokeWidth={2} />
              {isActive && (
                <div className="absolute left-0 w-1 h-8 bg-[#6366f1] rounded-r-full" />
              )}
              
              {/* Tooltip */}
              <div className="absolute left-full ml-3 px-3 py-1.5 bg-tooltip text-tooltip-foreground text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 shadow-lg">
                {item.label}
              </div>
            </button>
          );
        })}
      </div>

      {/* Bottom Navigation */}
      <div className="flex flex-col gap-2 w-full px-2 mb-4">
        {/* Theme Toggle */}
        <button
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          className="w-full h-12 rounded-xl flex items-center justify-center text-muted hover:text-foreground hover:bg-card-hover transition-all group relative"
          title={theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
        >
          {theme === 'dark' ? (
            <Sun className="w-5 h-5" strokeWidth={2} />
          ) : (
            <Moon className="w-5 h-5" strokeWidth={2} />
          )}
          
          {/* Tooltip */}
          <div className="absolute left-full ml-3 px-3 py-1.5 bg-tooltip text-tooltip-foreground text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 shadow-lg">
            {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
          </div>
        </button>

        {bottomItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className="w-full h-12 rounded-xl flex items-center justify-center text-muted hover:text-foreground hover:bg-card-hover transition-all group relative"
              title={item.label}
            >
              <Icon className="w-5 h-5" strokeWidth={2} />
              
              {/* Tooltip */}
              <div className="absolute left-full ml-3 px-3 py-1.5 bg-tooltip text-tooltip-foreground text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 shadow-lg">
                {item.label}
              </div>
            </button>
          );
        })}
        
        {/* User Avatar */}
        <button className="w-full h-12 rounded-xl flex items-center justify-center text-muted hover:text-foreground hover:bg-card-hover transition-all group relative mt-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] flex items-center justify-center">
            <User className="w-4 h-4 text-white" strokeWidth={2} />
          </div>
          
          {/* Tooltip */}
          <div className="absolute left-full ml-3 px-3 py-1.5 bg-tooltip text-tooltip-foreground text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 shadow-lg">
            Profile
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;